module.exports = __webpack_public_path__ + "img/2@2x.075387d8.png";